<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Qckyyj/tc-custom/9781429977852.jpg?1734751571327" alt="This image is the cover for the book Voyage of the Shadowmoon, The Moonworlds Saga"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Voyage of the Shadowmoon, The Moonworlds Saga
      </h1>
      <p class="bookDescription body article font2">
        <p><b>The renowned author of the Greatwinter novels delivers a "brilliantly inventive, marvelously plotted sea-faring fantasy that surpasses genre expectations" (</b><i><b>Kirkus</b></i><b>, starred review).</b></p><p>The <i>Shadowmoon</i> is a small wooden schooner whose passengers and crew are much more than they seem: Ferran, the Shadowmoon's lusty captain who dreams of power; Roval, the warrior-sorcerer; Velander and Terikel, priestesses of a nearly extinct sect; and the chivalrous vampyre Laron, who has been trapped in a fourteen-year-old body for 700 years.<br/><br/>They sail the coast, gathering useful information, passing as simple traders. But when they witness the awful power of Silverdeath, an uncontrollable doomsday weapon of awesome power, they realize they must act. But every single king, emperor and despot covets Silverdeath's power. It will take all of their wits and more than a little luck if they hope to prevent one of these power hungry fools from destroying the world. Their only advantage? The <i>Shadowmoon</i>.<br/><br/>While it seems to be a humble trading vessel, it is actually one of the most sophisticated ships in the world, one that allows them to travel to places where no others would dare. The crew must now hope it will be enough to save them all before Silverdeath rains destruction across their entire world.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Sean McMullen
      </h2>
      
      <p class="authorDescription body article"><B>Sean McMullen</B> is one of Australia’s leading science fiction authors. He established himself in the American market with the publication of the <I>Greatwinter trilogy</I> (comprised of<I> Souls in the Great Machine, The Miocene Arrow, </I>and<I> Eyes of the Calculor</I>), and is also the author of The Moonworlds Saga and <I>The Centurion's Empire</I>. The settings for Sean's work range from the Roman Empire, through Medieval Europe, to cities of the distant future. Sean spent several years in student reviews and theatre, and was lead singer in three rock and folk bands, and spent two years in the Victorian State Opera before he began writing.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Tom Doherty Associates
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?24bdad53